export default __webpack_public_path__ + "static/media/Ellipse 1.86532e9b.jpg";